/**
 * TK-48 §0.5 (lee 27/10) — HIỆU ỨNG (vòng chọn, ánh khi di chuột, nét chạy trên đường) của bản ChatGPT v06.
 *   · MẶC ĐỊNH TẮT. Người dùng bật trong menu tài khoản; nhớ qua `localStorage` (chỉ là sở thích — đọc hỏng ⇒ tắt).
 *   · `prefers-reduced-motion: reduce` ⇒ không bao giờ chạy, kể cả khi đã bật.
 *   · Tab ẩn ⇒ `data-fx-dung="1"` (CSS dừng mọi hoạt ảnh).
 *   · CHỈ trang trí: không hiệu ứng nào giả dữ liệu hay giả ACK.
 * Một kho cấp module (không đặt trong `useEffect`): menu và gốc trang đọc CÙNG một giá trị.
 */
import { useSyncExternalStore } from 'react';

export const KHOA_HIEU_UNG = 'sdkd-hieu-ung';

/** Thuần: hiệu ứng có chạy không. Mặc định (chưa lưu / đọc hỏng) = TẮT. */
export function hieuUngChay(daLuu: string | null, giamChuyenDong: boolean): boolean {
  return daLuu === 'bat' && !giamChuyenDong;
}

const docLuu = (): string | null => { try { return localStorage.getItem(KHOA_HIEU_UNG); } catch { return null; } };
const mq = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
let luu = typeof window !== 'undefined' ? docLuu() : null;
let lan = 0;
const nghe = new Set<() => void>();

function apDung() {
  if (typeof document === 'undefined') return;
  const g = document.documentElement;
  g.dataset.fx = hieuUngChay(luu, mq?.matches ?? false) ? 'on' : 'off';
  g.dataset.fxDung = document.hidden ? '1' : '0';
}
function bao() { lan++; apDung(); nghe.forEach((f) => f()); }

if (typeof window !== 'undefined') {
  apDung();
  mq?.addEventListener('change', bao);
  document.addEventListener('visibilitychange', apDung);
}

export function useHieuUng() {
  useSyncExternalStore((f) => { nghe.add(f); return () => { nghe.delete(f); }; }, () => lan);
  const giam = mq?.matches ?? false;
  return {
    bat: luu === 'bat',
    chay: hieuUngChay(luu, giam),
    giamChuyenDong: giam,
    doi: () => {
      luu = luu === 'bat' ? 'tat' : 'bat';
      try { localStorage.setItem(KHOA_HIEU_UNG, luu); } catch { /* chỉ là sở thích */ }
      bao();
    },
  };
}
